<template>
  <div id="storybook-preview-font-icons" :class="{ 'show-border': showBorder }">
    <Icon ref="icon" v-show="false" name="..."/>
    <StickyNav has-bg type="under-header" class="m-t-20">
      <div class="section-tool-menu">
        <div class="menu-item">Border: <el-switch v-model="showBorder"/> </div>
        <div class="menu-item">Add Class: <el-input v-model="classAdded" placeholder="Please input" style="max-width: 200px;"/> </div>
      </div>
    </StickyNav>
    <div class="p-l-40 p-r-40">
      <div v-for="type in iconTypes" :key="type.name" class="m-t-40">
        <h3 class="capitalize">{{ type.name }} Icons</h3>
        <ul class="unstyle">
          <li v-for="i in type.icons" :key="i">
            <Icon :name="i" :className="classAdded"/> {{ i }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Icon: () => import('../../../../../../lib/components/Icon.vue')
  },
  data () {
    return {
      iconTypes: [],
      showBorder: false,
      classAdded: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.iconTypes = Object.keys(this.$refs.icon.$data).map(name => ({ name, icons: Object.keys(this.$refs.icon.$data[name]).map(e => e) }))
      }, 1000)
    })
  }
}
</script>

<style lang="scss">
#storybook-preview-font-icons {

  .section-tool-menu {
    display: flex;
    gap: 24px;
    flex-direction: column;
    padding-left: 40px;
  }

  ul {
    column-count: 3;

    li {
      margin-bottom: 10px;

      i {
        margin-right: 5px;
      }
    }
  }

  &.show-border {
    ul {
      li {
        i {
          &.fantasticon, &.fontastic {
            &:before {
              border: solid 1px #ff0000;
            }
          }

          &.material-icons {
            border: solid 1px #ff0000;
          }
        }
      }
    }
  }
}
</style>
